























import { getSmsPurchasedProducts } from '@/api/Sms/sms.api'
import BuyProductCrudDialog from '@/components/Services/Sms/BuyProductCrudDialog.vue'
import { TableHeader } from '@/utils/interfaces'
import { BuySmsProduct } from '@/utils/interfaces/sms.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<BuySmsProduct>().extend({
  components: {
    BuyProductCrudDialog,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      getter: getSmsPurchasedProducts,
      headers: [
        { text: this.$t('remaining_amount'), value: 'remaining_amount' },
        { text: this.$t('agent'), value: 'agent_name' },
        { text: this.$t('product'), value: 'product_name' },
      ] as TableHeader[],
    }
  },
  methods: {
    onNew() {
      this.table.refresh()
    },
  },
})
